import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { StyledTag } from './MetaCRMTag.styles.js';
import { ReactComponent as SvgIcCancel } from '../assets/img/ic_cancel.svg.js';
import IconButton from '../Button/IconButton.js';
const _excluded = ["onDelete", "option", "deleteIconSize", "deleteIconColor", "deleteIconMarginLeft"];
function MetaCRMTag(props) {
  const {
      onDelete,
      option,
      deleteIconSize,
      deleteIconColor,
      deleteIconMarginLeft
    } = props,
    other = _objectWithoutProperties(props, _excluded);
  const handleDelete = e => {
    e.stopPropagation();
    onDelete();
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(StyledTag, _extends({
    backgroundColor: option.color,
    deleteIconSize: deleteIconSize,
    deleteIconColor: deleteIconColor,
    hasDeleteIcon: !!onDelete
  }, other), /*#__PURE__*/React__default.createElement("span", null, option.label), onDelete && /*#__PURE__*/React__default.createElement(IconButton, {
    size: deleteIconSize,
    sx: {
      marginLeft: "".concat(deleteIconMarginLeft, "px")
    },
    onClick: e => handleDelete(e)
  }, /*#__PURE__*/React__default.createElement(SvgIcCancel, null))));
}
MetaCRMTag.propTypes = {
  label: PropTypes.string,
  onDelete: PropTypes.func,
  option: PropTypes.shape({}),
  deleteIconSize: PropTypes.number,
  deleteIconColor: PropTypes.string,
  deleteIconMarginLeft: PropTypes.number
};
MetaCRMTag.defaultProps = {
  label: '',
  onDelete: null,
  option: {},
  deleteIconSize: 12,
  deleteIconColor: '#383538',
  deleteIconMarginLeft: 8
};
export { MetaCRMTag as default };